// src/pages/FreshMomentsPage.jsx

import useDiscoveryData from "../hooks/useDiscoveryData";
import DiscoverySectionPage from "../components/discovery/DiscoverySectionPage";
import {
  computeFreshMoments,
  computeRisingCreators,
  computeNearYouCreators,
  getDropAccess,
} from "../utils/discoveryPools";

export default function FreshMomentsPage() {
  const {
    drops, creators, dropsByCreator, creatorById,
    followingIds, currentUserCity, sessionSeed,
    purchasedDropIds, subscribedCreatorIds,
    loading,
  } = useDiscoveryData();

  if (loading) {
    return (
      <div className="gal-loading"><span className="gal-loading-text">Loading…</span></div>
    );
  }

  const getItems = ({ niche, search }) =>
    computeFreshMoments(drops, creatorById, { niche, search, limit: null });

  const getCardProps = (drop) => ({
    drop,
    creator:
      creatorById.get(drop.creatorId) ||
      { id: drop.creatorId, displayName: "Creator", avatarUrl: "" },
    access: getDropAccess(drop, purchasedDropIds, subscribedCreatorIds),
  });

  // Cross-promo: tease Rising and Near You so this page never dead-ends.
  const risingTeaser = computeRisingCreators(creators, dropsByCreator, { seed: sessionSeed, limit: 4 });
  const nearYouTeaser = computeNearYouCreators(creators, dropsByCreator, followingIds, currentUserCity, { seed: sessionSeed, limit: 4 });

  const crossPromo = [
    {
      key: "rising",
      title: "Rising · new to 100VO",
      seeAllPath: "/gallery/rising",
      itemType: "creator",
      items: risingTeaser,
      getCardProps: (creator) => ({ creator, openDropCount: creator.openCount, followingIds, isNew: true }),
    },
    nearYouTeaser.length > 0 && {
      key: "nearYou",
      title: `Near you${currentUserCity ? ` — ${currentUserCity}` : ""}`,
      seeAllPath: "/gallery/near-you",
      itemType: "creator",
      items: nearYouTeaser,
      getCardProps: (creator) => ({ creator, openDropCount: creator.openCount, followingIds }),
    },
  ].filter(Boolean);

  const allFresh = computeFreshMoments(drops, creatorById, { limit: null });

  return (
    <DiscoverySectionPage
      title="Fresh Moments"
      eyebrow="Newest first — no ranking, just the clock."
      itemType="drop"
      getItems={getItems}
      getCardProps={getCardProps}
      emptyMessage="Nothing fresh in this niche right now — check back soon."
      crossPromo={crossPromo}
      ctaStats={{ seenCount: allFresh.length, moreCount: Math.max(drops.length - allFresh.length, 0) }}
    />
  );
}